import React, { useMemo } from "react";
import { Prompt } from 'react-router-dom';

import ROUTES from '@/common/routes';
import useFilesInDocumentStore from '@/components/controls/DropScan/useFilesInDocument.store';
import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';
import { USE_MY_MONEY_UPLOAD_STORE_KEY } from '@/modules/UseMyMoney/UseMyMoney.types';

const UnsavedChangesPrompt = () => {
  const { values, showUnsavedChangesPrompt } = useMyMoneyFormStore();
  const { values: { documentId } } = useFilesInDocumentStore(USE_MY_MONEY_UPLOAD_STORE_KEY);

  const hasUnsavedChanges = useMemo(() => {
    return values?.amount
      || values?.providerId
      || values?.patientId
      || values?.dateOfService
      || values?.serviceId
      || values?.notes
      || values?.accountNumber
      || values?.invoiceNumber
      || documentId;
  }, [values, documentId]);

  return (
    <Prompt
      when={Boolean(hasUnsavedChanges && showUnsavedChangesPrompt)}
      message={(location) => {
        if (
          location.pathname === ROUTES.USE_MY_MONEY_SUMMARY ||
          location.pathname.startsWith(ROUTES.USE_MY_MONEY_SETUP_FIELDS)
        ) {
          return true;
        }
        return 'You have unsaved changes, are you sure you want to leave?';
      }}
    />
  );
};

export default UnsavedChangesPrompt;
